import configStore from "./configStore";

const store = configStore();

export default store;
